import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SetTargetsComponent } from './set-targets/set-targets.component';
import { SetTargetsToLeadSourcesComponent } from './set-targets-to-lead-sources/set-targets-to-lead-sources.component';
const routes: Routes = [
  {
    path: '',
    component: SetTargetsComponent
  },
  {
    path: 'setleadsourcetarget',
    component: SetTargetsToLeadSourcesComponent
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SetTargetsRoutingModule { }
